// Nota de revisão humana obrigatória (Regra 5 / Resolução CFM nº 2.454/2026). O GET
// não devolve a nota (o SOAP tem só os 4 campos), então o texto vive no cliente.
//
// FONTE DA VERDADE: espelha a constante NOTA_REVISAO de src/cli/soap.ts (a que o
// pipeline usa). O mockup exibia OUTRA redação ("Nota gerada com apoio de
// transcrição automática…") — mantive a do código por ser a canônica. A redação
// legal precisa ser confirmada com o médico/piloto (ver observação na entrega).

import type { CSSProperties } from 'react';

import { cor, fonte } from '../../styles/tokens';
import { CopiarBotao } from './CopiarBotao';

export const NOTA_REVISAO =
  'Rascunho gerado com assistência de IA. Exige revisão e validação do médico ' +
  'responsável antes de qualquer uso no prontuário (Resolução CFM nº 2.454/2026).';

const caixa: CSSProperties = {
  marginTop: 'auto',
  border: `1px solid rgba(29,31,32,.28)`,
  background: cor.cabecalhoCampo,
  padding: 12,
};

export function NotaRevisao(): JSX.Element {
  return (
    <div style={caixa}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 7 }}>
        <span
          style={{ fontFamily: fonte.mono, fontSize: 10, letterSpacing: '.12em', color: cor.muted }}
        >
          NOTA DE REVISÃO — OBRIGATÓRIA
        </span>
        <span
          style={{
            marginLeft: 'auto',
            display: 'inline-flex',
            alignItems: 'center',
            fontSize: 9.5,
            padding: '1px 6px',
            border: `1px solid ${cor.azul}`,
            color: cor.azul,
            letterSpacing: '.02em',
          }}
        >
          CFM 2.454/2026
        </span>
      </div>
      <div
        style={{
          fontFamily: fonte.serif,
          fontSize: 12.5,
          lineHeight: 1.55,
          color: cor.texto,
          background: cor.branco,
          border: `1px solid rgba(29,31,32,.14)`,
          padding: '8px 10px',
        }}
      >
        {NOTA_REVISAO}
      </div>
      <CopiarBotao
        texto={NOTA_REVISAO}
        rotulo="Copiar nota de revisão"
        style={{ width: '100%', height: 38, marginTop: 9 }}
      />
    </div>
  );
}
